import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('FILING_OPTIONS_SELECTOR', LOG_LEVELS.DEBUG);

class FilingOptionsSelector extends Component {
  selectionChangeHandler(event) {
    log.debug('selectionChangeHandlerFactory(): %s, ', event);
    const selectedKey = event.detail.item.value;
    log.debug('selectionChangeHandlerFactory(): selectedKey:', selectedKey);
    if (selectedKey < 0) {
      this.props.selectionHandler(null, true);
    }
    else {
      this.props.selectionHandler(this.props.options[selectedKey], true);
    }
  }

  render() {
    log.debug('render(): ', this.props);
    const options = this.props.options || [];
    log.debug('render(): isFilingTypeSelected');

    const outputTypeCounts = options.reduce((counts, option) => {
      if (!counts[option.outputType]) {
        counts[option.outputType] = 0;
      }
      counts[option.outputType]++;

      return counts;
    }, {});
    log.debug('render: outputTypeCounts:', outputTypeCounts);
    let selectorOptions = options.map( (option, key) => {
      let newValue ={};
      newValue.key = key;
      if(outputTypeCounts[option.outputType] > 1) {
        newValue.value = `${option.outputType}: (${option.name})`;
      } else {
        newValue.value  = `${option.outputType}`;
      }
      return newValue;
    });
    selectorOptions = this.props.sorted ? selectorOptions.sort( (first, second) =>  first.value > second.value ? 1: -1) : selectorOptions;
    
    // Find selected option index
    const selectedIndex = this.props.selection 
      ? options.findIndex(opt => opt.name === this.props.selection.name && opt.outputType === this.props.selection.outputType)
      : -1;
    const selectedValue = selectedIndex >= 0 ? selectedIndex.toString() : '-1';

    // Create options list for SSelect
    const optionsList = [
      {
        key: '-1',
        value: '-1',
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingFilingPreparationOutputType"),
        selected: selectedValue === '-1'
      },
      ...selectorOptions.map((option) => ({
        key: option.key.toString(),
        value: option.key.toString(),
        label: option.value,
        selected: selectedValue === option.key.toString()
      }))
    ];
    
    return (
        <fieldset className="mb10">
          <label htmlFor="filing-options-selector"><LanguageStringResolver string={this.props.selectorLabelString} /></label>
          <SSelect
            inputId="filing-options-selector"
            data-testid="filing-options-selector"
            optionsList={optionsList}
            value={selectedValue}
            multiple={false}
            disabled={this.props.disabled}
            onS-select={this.selectionChangeHandler.bind(this)}
          />
        </fieldset>
    );
  }
}


FilingOptionsSelector.defaultProps = {
  sorted: false,
  disabled: false
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {
    languages: state.languages
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FilingOptionsSelector);
